import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { useNavigate, Link, useParams, useLocation  } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Position = () => {
  const navigate = useNavigate();
  const { dokumentNummer, intnummer } = useParams();
  const { state } = useLocation();
  const kommission = state?.kommission ?? '';
  const kom1 = state?.kom1 ?? '';
  const sachbearbeiter = state?.sachbearbeiter ?? '';
  const strasse = state?.strasse ?? '';

  const [daten, setdaten] = useState([]);
  const [loading, setLoading] = useState(true);
  const [username, setusername] = useState('');
  const [kontrolliert, setKontrolliert] = useState(''); // '' | 'ja' | 'nein'

  // === Daten laden ===
  useEffect(() => {
    if (localStorage.getItem("loginData") == null) {
      navigate("/dhworld/login");
      return;
    }

    var d = JSON.parse(localStorage.getItem("loginData"));
    setusername(d.username);

    const loadData = async () => {
      try {
        const res = await axios.get(
          `https://dhworld.dietenmeier-harsch.de/getPositionen.php?ts=${Date.now()}&nummer=${dokumentNummer}&intnummer=${intnummer}`
        );
        const initial = (res.data.daten || []).map(d => ({
          ...d,
          pickMenge: d.pickMenge || '',
          lagerMenge: d.lagerMenge || '',
          status: d.status || 'offen',
          error: true,
        }));
        setdaten(initial);
      } catch (err) {
        console.error("Fehler beim Laden der Positionen:", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [dokumentNummer, intnummer]);

  const allowNegativeForPick = (item) => {
    const r = parseFloat(String(item.richtMenge).replace(',', '.'));
    // Sonderfall: Richtmenge == -1 oder leer
    return isNaN(r) || r === -1;
  };
// === Eingabevalidierung ===
const validateNumber = (value, allowNegative = false) => {
  if (value === '') return '';
  const cleaned = value.replace(',', '.');

  // Nur Ziffern und optional Dezimalpunkt; optional führendes Minus
  const regex = allowNegative ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
  if (!regex.test(cleaned)) return '';

  // Verhindere Zwischenstände wie "-" oder "." oder "-."
  if (cleaned === '-' || cleaned === '.' || cleaned === '-.') return '';

  return cleaned;
};

// === Wert aktualisieren ===
const handleInputChange = (index, field, value) => {
  const updated = [...daten];
  const row = updated[index];

  // Nur für Pick-Menge im Sonderfall -1 Negative erlauben
  const allowNeg = field === 'pickMenge' && allowNegativeForPick(row);

  const valid = validateNumber(value, allowNeg);
  row[field] = valid;
  setdaten(updated);
};

// === + / - Buttons ===
const adjustValue = (index, field, delta) => {
  const updated = [...daten];
  const row = updated[index];

  let current = parseFloat(row[field] || 0);
  if (isNaN(current)) current = 0;

  const negAllowedForPick = field === 'pickMenge' && allowNegativeForPick(row);

  // neuen Wert berechnen
  let next = current + delta;

  if (negAllowedForPick) {
    // Untergrenze -1 (explizit gefordert)
    if (next < -1) next = -1;
  } else {
    // normale Fälle: nicht unter 0
    if (next < 0) next = 0;
  }

  row[field] = String(next);
  setdaten(updated);
};

 // === Schloss toggeln ===
const toggleStatus = (index) => {
  const updated = [...daten];
  const item = updated[index];

  if (item.status === 'geschlossen') {
    // wieder öffnen -> Eingaben erlauben, Fehler zurücksetzen
    item.status = 'offen';
    item.error = true;
    setdaten(updated);
    return;
  }

  // --- Abschließen prüfen ---
  // Pick-Menge darf nicht leer sein
  if (item.pickMenge === '' || item.pickMenge === null || typeof item.pickMenge === 'undefined') {
    toast.warning(`Position ${item.ArtPos_ArtikelNummer}: Pick-Menge darf nicht leer sein!`);
    item.error = true;
    item.status = 'offen';
    setdaten(updated);
    return;
  }

  const richt = parseFloat(String(item.richtMenge).replace(',', '.'));
  const pick  = parseFloat(String(item.pickMenge).replace(',', '.'));

  const negAllowed = allowNegativeForPick(item);

  if (negAllowed) {
    // Sonderfall: Richtmenge -1 oder leer -> Pick MUSS -1 sein (so gewünscht)
    if (pick !== -1) {
      toast.warning(`Position ${item.ArtPos_ArtikelNummer}: Im Sonderfall muss die Pick-Menge genau -1 sein.`);
      item.error = true;
      item.status = 'offen';
      setdaten(updated);
      return;
    }
  } else {
    // Normalfall: Pick == 0 ODER Pick >= Richt; niemals kleiner als Richt
    // (wenn richt NaN wäre, behandeln wir als 0)
    const r = isNaN(richt) ? 0 : richt;
    if (!(pick === 0 || pick >= r)) {
      toast.warning(`Position ${item.ArtPos_ArtikelNummer}: Pick-Menge darf nicht kleiner als Richt-Menge sein (außer 0).`);
      item.error = true;
      item.status = 'offen';
      setdaten(updated);
      return;
    }
  }

  // bestanden -> schließen & grün
  item.status = 'geschlossen';
  item.error = false;
  setdaten(updated);
};

// === Absenden ===
const handleSubmit = async () => {
  const openOrError = daten.filter(d => d.status !== 'geschlossen' || d.error);
  if (openOrError.length > 0) {
    const updated = daten.map(d => ({
      ...d,
      error: d.status !== 'geschlossen' || d.error,
    }));
    setdaten(updated);
    toast.error("Es gibt noch offene Positionen, bitte zuerst abschließen!");
    return;
  }

  if (!kontrolliert) {
    toast.error("Bitte auswählen, ob durch Büro kontrolliert wurde (Ja oder Nein).");
    return;
  }

  try {
    setLoading(true);

    // → alle Positionen, die gesendet werden sollen:
    const payload = {
      dokumentNummer,
      intnummer,
      kommission,
      kom1,
      sachbearbeiter,
      strasse,
      username,
      kontrolliertDurchBuero: kontrolliert,
      positionen: daten.map(d => ({
        artikelnummer: d.ArtPos_ArtikelNummer,
        bezeichnung: d.ArtPos_Bezeichnung,
        richtMenge: d.richtMenge,
        pickMenge: d.pickMenge,
        lagerMenge: d.lagerMenge,
        artReferenz: d.Art_Referenz,
        status: d.status,
      })),
    };

    const res = await axios.post(
      'https://dhworld.dietenmeier-harsch.de/create.php',
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );

    console.log("Response create.php:", res.data);
    toast.success(`Excel-Datei für Bestellung ${dokumentNummer} erfolgreich erzeugt!`);
  } catch (err) {
    console.error("Fehler beim Senden an create.php:", err);
    toast.error("Fehler beim Erzeugen der Excel-Datei!");
  } finally {
    setLoading(false);
    navigate("/dhpick");
  }
};

  if (loading) {
    return (
      <div className="text-center" style={{ paddingTop: "150px" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#eceff2', minHeight: '100vh' }} className="container-fluid">
      <ToastContainer position="top-center" autoClose={2500} />
      <div className="row pt-4">
        <div className='col-12'>
          <Link to="/dhpick">
            <i style={{ fontSize: '25px' }} className="bi bi-arrow-return-left"></i>
          </Link>
          <br /><br />
          <h1>Positionen zur Bestellung {dokumentNummer}</h1>
        </div>
      </div>

      <br /><br />

      <Row className="g-4">
        {daten && daten.length > 0 ? (
          <div className="table-responsive-sm">
            <Table bordered hover>
              <thead>
                <tr>
                  <th>ArtNr</th>
                  <th>Bezeichnung</th>
                  <th><strong>Richt-Menge</strong></th>
                  <th>Pick-Menge</th>
                  <th>Neue Lagermenge</th>
                  <th>Artikel-Referenz</th>
                  <th>Bild</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {daten.map((v, index) => {
                  // === Hintergrundfarbe je nach Status ===
                  let bgColor = '#fff';
                  if (v.error) {
                    bgColor = '#ffcccc'; // rot
                  } else if (v.status === 'geschlossen') {
                    bgColor = '#c8f7c5'; // grün
                  }

                  return (
                    <tr key={index} style={{ backgroundColor: bgColor }}>
                      <td>{v.ArtPos_ArtikelNummer}</td>
                      <td>{v.ArtPos_Bezeichnung}</td>
                      <td><strong>{v.richtMenge}</strong></td>

                      {/* Pick-Menge mit +/- */}
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-1 flex-nowrap">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            style={{ minWidth: '32px' }}
                            disabled={v.status === 'geschlossen'}
                            onClick={() => adjustValue(index, 'pickMenge', -1)}
                          >
                            <i className="bi bi-dash-lg"></i>
                          </Button>
                          <input
                            type="text"
                            className="form-control text-center"
                            style={{
                              minWidth: '85px',
                              flexGrow: 1,
                              fontSize: '0.9rem',
                            }}
                            value={v.pickMenge}
                            disabled={v.status === 'geschlossen'}
                            onChange={(e) => handleInputChange(index, 'pickMenge', e.target.value)}
                            onBlur={(e) => handleInputChange(index, 'pickMenge', validateNumber(e.target.value))}
                          />
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            style={{ minWidth: '32px' }}
                            disabled={v.status === 'geschlossen'}
                            onClick={() => adjustValue(index, 'pickMenge', 1)}
                          >
                            <i className="bi bi-plus-lg"></i>
                          </Button>
                        </div>
                      </td>

                      {/* Neue Lagermenge */}
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-1 flex-nowrap">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            style={{ minWidth: '32px' }}
                            disabled={v.status === 'geschlossen'}
                            onClick={() => adjustValue(index, 'lagerMenge', -1)}
                          >
                            <i className="bi bi-dash-lg"></i>
                          </Button>
                          <input
                            type="text"
                            className="form-control text-center"
                            style={{
                              minWidth: '85px',
                              flexGrow: 1,
                              fontSize: '0.9rem',
                            }}
                            value={v.lagerMenge}
                            disabled={v.status === 'geschlossen'}
                            onChange={(e) => handleInputChange(index, 'lagerMenge', e.target.value)}
                            onBlur={(e) => handleInputChange(index, 'lagerMenge', validateNumber(e.target.value))}
                          />
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            style={{ minWidth: '32px' }}
                            disabled={v.status === 'geschlossen'}
                            onClick={() => adjustValue(index, 'lagerMenge', 1)}
                          >
                            <i className="bi bi-plus-lg"></i>
                          </Button>
                        </div>
                      </td>

                      <td>{v.Art_Referenz}</td>

                      {/* Bild-Link */}
                      <td className="text-center">
                        {v.bild ? (
                          <i
                            className="bi bi-image"
                            style={{ fontSize: '20px', color: '#007bff', cursor: 'pointer' }}
                            onClick={() => window.open(`https://dhworld.dietenmeier-harsch.de/daten/${v.bild}`, '_blank')}
                          ></i>
                        ) : (
                          <i className="bi bi-image text-secondary"></i>
                        )}
                      </td>

                      {/* Schloss / Status */}
                      <td className="text-center">
                        <i
                          className={`bi ${v.status === 'geschlossen' ? 'bi-lock-fill text-success' : 'bi-unlock text-secondary'}`}
                          style={{ fontSize: '20px', cursor: 'pointer' }}
                          onClick={() => toggleStatus(index)}
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <Col xs={12}>
            <div
              style={{
                background: '#fff',
                padding: '1rem',
                borderRadius: '8px',
                textAlign: 'center'
              }}
            >
              Keine Positionen vorhanden
            </div>
          </Col>
        )}
      </Row>

            {/* Checkbox-Bereich */}
            <div className="mb-3 mt-4">
        <h5>Kontrolliert durch Büro?</h5>
        <Form>
          <Row>
            <Col xs="auto">
              <Form.Check
                type="radio"
                label="Ja"
                name="kontrolle"
                value="ja"
                checked={kontrolliert === 'ja'}
                onChange={(e) => setKontrolliert(e.target.value)}
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="radio"
                label="Nein"
                name="kontrolle"
                value="nein"
                checked={kontrolliert === 'nein'}
                onChange={(e) => setKontrolliert(e.target.value)}
              />
            </Col>
          </Row>
        </Form>
      </div>

      {/* === Absenden-Button === */}
      <div className="text-center my-4">
        <Button
          onClick={handleSubmit}
          style={{
            backgroundColor: '#007bff',
            border: 'none',
            padding: '12px 40px',
            borderRadius: '10px',
            fontWeight: '600',
            fontSize: '16px',
            boxShadow: '0 0 10px rgba(0,123,255,0.5)',
          }}
        >
          Absenden
        </Button>
      </div>
    </div>
  );
};

export default Position;
